const singleProductAccordion = () => {
  const accordions = document.querySelectorAll('.panel') as NodeListOf<HTMLElement>;
  const activeClass = 'panel--active';

  accordions.forEach((accr: HTMLElement) => {
    const title = accr.querySelector('.panel__header') as HTMLElement;
    const content = accr.querySelector('.panel__content') as HTMLElement;
    const contentInner = accr.querySelector('.panel__inner') as HTMLElement;
    const icon = title.lastElementChild;
    const panelHeight = contentInner.offsetHeight + 100;

    title.addEventListener('click', () => {
      if (accr.classList.contains(activeClass)) {
        accr.classList.remove(activeClass);
        contentInner.style.maxHeight = `${panelHeight}px`;
        content.style.maxHeight = '0px';
        icon.classList.remove('fa-angle-up');
        icon.classList.add('fa-angle-down');
      } else {
        accr.classList.add(activeClass);
        content.style.maxHeight = `${panelHeight}px`;
        icon.classList.remove('fa-angle-down');
        icon.classList.add('fa-angle-up');
      }
    });
  });

  // open first accordion tab on click
  const desktopContentTitle = document.querySelectorAll('.desktopcontent__header-title') as NodeListOf<HTMLElement>;
  const mobileContentHeader = document.querySelectorAll('.panel__header') as NodeListOf<HTMLElement>;
  const readMore: HTMLAnchorElement = document.querySelector('.woocommerce-product-details__short-description-readmore');
  readMore?.addEventListener('click', () => {
    desktopContentTitle[0].click();
    mobileContentHeader[0].click();

    if (window.outerWidth < 768) {
      mobileContentHeader[0].scrollIntoView();
    } else {
      desktopContentTitle[0].scrollIntoView();
    }
  });
};

export default singleProductAccordion;
